// extracted by mini-css-extract-plugin
export default {"fillButton":"fill-bag_fillButton__KdRBK","editPanel":"fill-bag_editPanel__j5Y9K"};